import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbDialogService, NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { Router, ActivatedRoute } from '@angular/router';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { MyMenuService } from '../../../tool/service/menu.service';
import { PAGE_CODE_MAP, TranslationService } from '../../../tool/language/translation.service';

import { HomeComponent } from '../../../main/sys/home/home.component';

import { SubscriptService } from '../../../tool/service/header.service';
import { Subject, Observable } from 'rxjs';



@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('languageDialog', { static: false }) languageDialog: TemplateRef<any>;

  private destroy$: Subject<void> = new Subject<void>();
  private readonly showLanguageSwitcher = false;
  selectedLanguage = 'zh-TW';
  languageOptions = [
    { value: 'zh-TW', label: '繁體中文' },
    { value: 'en-US', label: 'English' },
    { value: 'ja-JP', label: '日本語' },
  ];
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [
    { title: '登出', data: 'logout' },
  ];

  //基本資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  CompanyName:string;
  authChangeSub:any;
  USR_POSEmployeeInfo_ID: string;
  //查詢的門市
  storeSelectList: selectData[];
  selectORG_Store_ID: number;
  menuSub : any;

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private cookieService: CookieService,
    private _router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private http: HttpClient,
    private ms: MyMenuService,
    private hs: SubscriptService,
    private home: HomeComponent,
    private dialogService: NbDialogService,
    private translationService: TranslationService) {

    

      console.log('header menu init')
      this.menuSub = menuService.onItemClick().subscribe((event) => {
        if (event.item.data === 'language' && this.showLanguageSwitcher) {
          this.openLanguageDialog();
        }

        if (event.item.data === 'logout') {
          this.ms.logout();
        }
        
      });

      console.log('已訂閱 content AuthUpdata$')    
      this.hs.AuthUpdata$.subscribe(val => {
        console.log('hs 已收到content變動',val)
        this.getStoreList()
      });
  
  }


  ngOnInit() {
    this.selectedLanguage = this.translationService.initLanguage();
    void this.translationService.fetchTranslationsFromApi(PAGE_CODE_MAP.common, this.selectedLanguage)
      .then((translations) => {
        this.translationService.mergeTranslations(translations);
      });
    this.updateUserMenu();
    this.translationService.languageChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe((languageCode) => {
        this.selectedLanguage = languageCode;
        this.updateUserMenu();
      });
   
   


    this.USR_POSEmployeeInfo_ID = this.cookieService.get('USR_POSEmployeeInfo_ID');
    this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null
    
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID');
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'));
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID = (cookie_sid && cookie_sid != '') ? parseInt(cookie_sid) : null




    this.currentTheme = this.themeService.currentTheme;
    // this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((users: any) => this.user = users.nick);

    this.user = new Object();
    this.user.name = this.cookieService.get('NickName');
    this.user.picture = this.cookieService.get('PhotoURL');
    this.CompanyName = this.cookieService.get('CompanyName'); 

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);


    if (this.USR_AccountInfo_ID != null) {
      this.getStoreList();
    }
  }

  ngOnDestroy() {

    if (this.menuSub) {
      this.menuSub.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  
  //開關左邊欄
  toggleSidebar(): boolean {
   
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  openLanguageDialog(): void {
    if (!this.languageDialog) {
      return;
    }

    this.dialogService.open(this.languageDialog, {
      dialogClass: 'language-dialog-window',
      hasScroll: false,
      closeOnBackdropClick: true,
      closeOnEsc: true,
    });
  }

  onHeaderLanguageChange(languageCode: string, dialogRef?: any): void {
    this.selectedLanguage = languageCode;
    const pageCodes = [...new Set([
      ...PAGE_CODE_MAP.common,
      ...this.translationService.getCurrentPageCodes(),
    ])];
    void this.translationService.setLanguage(languageCode, pageCodes);
    if (dialogRef) {
      dialogRef.close();
    }
  }

  getLanguageDialogTitle(): string {
    return this.translationService.getText('language_dialog_title');
  }

  getCloseText(): string {
    return this.translationService.getText('common_close');
  }

  private updateUserMenu(): void {
    const languageCode = this.selectedLanguage || this.translationService.getCurrentLanguage();

    if (!this.showLanguageSwitcher) {
      if (languageCode === 'en-US') {
        this.userMenu = [
          { title: 'Logout', data: 'logout' },
        ];
        return;
      }

      if (languageCode === 'ja-JP') {
        this.userMenu = [
          { title: 'ログアウト', data: 'logout' },
        ];
        return;
      }

      this.userMenu = [
        { title: '登出', data: 'logout' },
      ];
      return;
    }

    if (languageCode === 'en-US') {
      this.userMenu = [
        { title: 'Language', data: 'language' },
        { title: 'Logout', data: 'logout' },
      ];
      return;
    }

    if (languageCode === 'ja-JP') {
      this.userMenu = [
        { title: '言語', data: 'language' },
        { title: 'ログアウト', data: 'logout' },
      ];
      return;
    }

    this.userMenu = [
      { title: '語言', data: 'language' },
      { title: '登出', data: 'logout' },
    ];
  }









  upSelect: boolean = false;
  //取得門市清單
  getStoreList() {//取得門市清單 USP_YOPOSWebGetStoreList

    console.log('hs 更新門市清單')


    this.http.post<any>('api/ORGStore/StoreList', {
      USR_AccountInfo_ID: this.USR_AccountInfo_ID ? this.USR_AccountInfo_ID : 'empty',
      USR_EmployeeInfo_ID: this.USR_EmployeeInfo_ID,
      ORG_Company_ID: this.ORG_Company_ID,
      USR_POSEmployeeInfo_ID: this.USR_POSEmployeeInfo_ID,
    }).subscribe({
      next: data => {
        this.storeSelectList = [];
        data.LIST.forEach(element => {
          //門市共用下拉選單
          var selectItem = new selectData();
          selectItem.value = element.ORG_Store_ID;
          selectItem.content = element.StoreName;
          this.storeSelectList.push(selectItem);
        });

        // 預設點第一個
        if (this.storeSelectList.length > 0) {
          let obj = this.storeSelectList.find(x=>x.value ==  this.ORG_Store_ID )
          if(obj)  {
            this.selectORG_Store_ID = obj.value
            this.selectStoreChange(obj.value)
          }        
          else{
            this.selectORG_Store_ID = this.storeSelectList[0].value
            this.selectStoreChange(this.storeSelectList[0].value)
          }
         
        }
        this.upSelect = !this.upSelect



      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

  }
  //選擇門市
  selectStoreChange(event) {

   
   
    this.cookieService.set('ORG_Store_ID', event,1,'/');
    this.selectORG_Store_ID = event
    this.ORG_Store_ID = event

    console.log('hs變更了內容!')
    this.hs.AuthChangeSubject.next(event)
   

    this.ms.getMenu()
    this.home.GetContractRd();
  }





  // changeTheme(themeName: string) {
  //   this.themeService.changeTheme(themeName);
  // }

  // navigateHome() {
  //   this.menuService.navigateHome();
  //   return false;
  // }



}


class selectData {
  value: number;//
  content: string;//

}
